import DonationFormCaptcha from './DonationFormCaptcha'

export default DonationFormCaptcha
